import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PortalService } from '@vsolv/packages/portal-config/web';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './privacy-policy.page.html',
  standalone: false,
})
export class PrivacyPolicyPage {
  constructor(private portalSvc: PortalService) {}

  contactEmail = this.portalSvc.config.contactEmail;
  contactPhone = this.portalSvc.config.contactPhone;
}
